import dsnAxios from '../services/axios';

const JOB_MANAGER_ENDPOINT = `jobs`;

export async function startJob({ name, params, wait, pollingInterval = 10 }) {
  console.debug(`Trying to start job ${name}`);

  const jobStartResult = await dsnAxios.post(JOB_MANAGER_ENDPOINT, {
    name,
    params
  });
  const jobId = jobStartResult.data?.result?.id;

  console.debug(`Job ${name} started with ID: ${jobId}`);

  if (!wait) {
    return {
      id: jobId
    };
  }

  if (jobId && wait) {
    return new Promise((resolve, reject) => {
      const intervalId = setInterval(async () => {
        console.debug(`Checking job status: ${jobId}`);
        const jobResult = await dsnAxios.get(
          `${JOB_MANAGER_ENDPOINT}/${jobId}`
        );
        const status = jobResult.data?.status;

        if (status !== 'pending') {
          console.debug(`Job ${jobId} finished with status: ${status}`);
          clearInterval(intervalId);

          const { result, error } = jobResult.data;
          resolve({ id: jobId, status, result, error });
        }
      }, pollingInterval * 1000);
    });
  }
}

export async function startJobSequence({ jobs, params, pollingInterval }) {}

export const STATUS = {
  IN_PROGRESS: 'in-progress',
  SUCCESS: 'success',
  SUCCESS_WITH_ERRORS: 'success_with_errors',
  ERROR: 'error',
  ABORTED: 'aborted',
  SKIPPED: 'skipped'
};
